<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 32"
    class="icon-svg icon-amex"
  >
    <g
      fill="none"
      fill-rule="evenodd"
    >
      <g
        transform="translate(-1176 -906) translate(1176 140) translate(0 614) translate(0 152)"
      >
        <rect
          width="47"
          height="31"
          x=".5"
          y=".5"
          stroke="#d5d5d5"
          fill="#FFFFFF"
          rx="4"
        />
        <g fill-rule="nonzero">
          <path
            fill="#26337A"
            d="M11.307 10.071L12.854.473 15.328.473 13.78 10.071zM22.752.708c-.49-.192-1.259-.402-2.217-.402-2.445 0-4.166 1.302-4.18 3.167-.016 1.38 1.228 2.15 2.166 2.608.963.47 1.287.77 1.283 1.191-.006.643-.769.938-1.48.938-.99 0-1.516-.145-2.33-.504l-.318-.153-.346 2.149c.577.267 1.646.5 2.756.512 2.598 0 4.287-1.287 4.307-3.279.009-1.094-.65-1.923-2.078-2.608-.864-.445-1.394-.74-1.388-1.19 0-.4.448-.826 1.417-.826.808-.013 1.394.173 1.85.368l.223.11.335-2.08zM26.045 6.668c.205-.551.985-2.683.985-2.683-.015.026.204-.556.329-.915l.167.827s.474 2.291.572 2.771h-2.053zM29.096.483h-1.911c-.593 0-1.037.17-1.296.795l-3.673 8.797h2.597s.424-1.184.52-1.443l3.168.005c.074.335.301 1.438.301 1.438h2.296L29.096.483zM6.811 7.025l-.26-1.33C6.102 4.161 4.698 2.5 3.127 1.667l2.214 8.395 2.618-.002 3.895-9.58H9.232l-2.42 6.544z"
            transform="translate(8 11)"
          />
          <path
            fill="#EC982D"
            d="M4.564.474H.576l-.033.2c3.103.794 5.157 2.713 6.01 5.02l-.868-4.41c-.15-.608-.584-.788-1.12-.81z"
            transform="translate(8 11)"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
